import { AssetReference } from '@opallabs/cassini'

export type Asset = AssetReference

export type LinkWithData = {
  url: string
  title: string
  domain: string
  description: string
  assetReferences: Asset[]
}

type OnLinkDataUpdateValue = {
  url: LinkWithData['url']
  title: LinkWithData['title']
  domain: LinkWithData['domain']
  description: LinkWithData['description']
  asset_references: LinkWithData['assetReferences']
}

export type OnLinkDataUpdate =
  // With name: 'url', you can init a full LinkWithData object
  ((value: OnLinkDataUpdateValue, name: 'url', link: string) => void) &
    // With name: 'reset', there is no value
    ((value: null, name: 'reset', link: string) => void) &
    // For all others, you can set by key-value pairs from LinkWithData
    (<TKey extends keyof Omit<OnLinkDataUpdateValue, 'url'>>(
      value: OnLinkDataUpdateValue[TKey],
      name: TKey,
      link: string
    ) => void)

export type OnAddSectionProps = {
  componentName?: string
  index?: number
}

export type OnShowAssetPickerProps = {
  destination?: string
  index?: number
  url?: string
  allowMultiple?: number
  uploadType?: 'image' | 'video'
}

export type GetContentByIDV2Return = {
  payload: {
    [key: string]: string
  }
}

export type OnDragDropProps = (
  e: React.DragEvent<HTMLDivElement>,
  args: OnShowAssetPickerProps
) => void

export enum ContentPreviewState {
  EMPTY = 'empty',
  ERROR = 'error',
  LOADED = 'loaded',
  LOADING = 'loading',
}

export type ContentPreviewStateReturn = {
  embedlyPreview: null | string
  state: ContentPreviewState
}

export type ModuleDefinition = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<any>
  componentName: string
  title: string
}

export type GenericIdAndTitle = {
  id?: number
  title?: string
}

export type PostOption = {
  content: string | GenericIdAndTitle[]
  group?: string
  group_id?: number
  option: string
  required?: boolean
  selected?: GenericIdAndTitle
  type: string
  validation?: string
}

export type NullablePostOption =
  | PostOption
  | string
  | null
  | number
  | undefined
  | AssetReference
  | AssetReference[]

export type ModuleBase = {
  componentName?: string
  name?: string
  id: number
  position: number
  title?: string
}

export type SectionPostOptions = {
  [key: string]: NullablePostOption
}

export type Module = ModuleBase & SectionPostOptions

export type UploadType = 'image' | 'video' | 'mixed' | number

export type GetSectionPostOptionsProps = {
  sectionPostOptions?: SectionPostOptions
  module?: Module
}
